export default {
  homePage: '/',
  workPage: '/Portfolio',
};
